import {
    MdHowToReg,
    MdLogout,
    MdMeetingRoom,
    MdSwapHoriz,
} from 'react-icons/md'
import {
    PRESENCE_EVENT_LABELS,
    PresenceEvent,
    PresenceEventType,
} from '@/lib/api/presence/presence-api'

const EVENT_ICONS: Record<PresenceEventType, typeof MdHowToReg> = {
    ARRIVED: MdHowToReg,
    STATUS_CHANGED: MdSwapHoriz,
    ROOM_CHANGED: MdMeetingRoom,
    FINISHED: MdLogout,
}

function formatDateTime(value: string): string {
    return new Date(value).toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    })
}

/** Detalhe que acompanha o rótulo do movimento (o controle ou a sala aplicados). */
function describe(event: PresenceEvent): string {
    if (event.type === 'ROOM_CHANGED') {
        return event.room ? `: ${event.room.name}` : ''
    }
    if (event.type === 'ARRIVED' || event.type === 'STATUS_CHANGED') {
        return event.status ? `: ${event.status.name}` : ''
    }
    return ''
}

/**
 * Movimentos de uma passagem pelo balcão, em ordem cronológica.
 *
 * Compartilhado pela ficha do agendamento e pela busca do modal — as duas
 * mostram a mesma coisa, e duplicar a renderização faria uma divergir da outra
 * na primeira mudança.
 */
export default function PresenceEventList({
    events,
}: {
    events: PresenceEvent[]
}) {
    if (events.length === 0) return null

    return (
        <ul className="mt-3 flex flex-col gap-3">
            {events.map(event => {
                const Icon = EVENT_ICONS[event.type]
                return (
                    <li key={event.id} className="flex items-start gap-3">
                        <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-base-100 text-base-content/70">
                            <Icon className="text-base" />
                        </span>
                        <div className="min-w-0 flex-1">
                            <p className="text-sm font-medium">
                                {PRESENCE_EVENT_LABELS[event.type]}
                                {describe(event)}
                            </p>
                            <p className="text-xs text-base-content/60">
                                {formatDateTime(event.createdAt)}
                                {event.createdBy && ` · ${event.createdBy.name}`}
                            </p>
                        </div>
                    </li>
                )
            })}
        </ul>
    )
}
